import { Button } from '@components/button';
import { DatePicker } from '@components/datepicker';
import { getPlaceholderHtml as getDatePlaceholderHtml } from '@components/field-mapping-date-picker/extensions';
import { IconAddPlus } from '@components/icons/add-plus';
import { Text } from '@components/text/text';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';
import { abbreviateDate } from '@utils/date';

import { EditorRefProp } from '../common';
import { DateManualRestrictions, locale } from '../field-mapping-sidebar';

type DateManualFieldProps = EditorRefProp & {
  dateRestrictions?: DateManualRestrictions;
};

export const DateManualField = ({ editorRef, dateRestrictions }: DateManualFieldProps) => {
  const { t } = useScopedTranslate(locale);

  const onChange = (date: Date) => {
    const label = abbreviateDate(date, 'en');
    editorRef.current?.insertContent(getDatePlaceholderHtml({ value: date.toISOString(), label }));
  };

  return (
    <DatePicker
      label={t('dateLabel')}
      hideLabel
      disableClear
      onChange={onChange}
      disablePastDates={dateRestrictions?.disablePastDates}
      disableFutureDates={dateRestrictions?.disableFutureDates}
      minDate={dateRestrictions?.minDate}
      maxDate={dateRestrictions?.maxDate}
      customInput={
        <Button
          iconLeft={<IconAddPlus />}
          variant="secondary"
          text={t('manuallySelectDate')}
          style={{ width: 'fit-content' }}
        >
          <IconAddPlus />
          <Text
            text={t('manuallySelectDate')}
            font="semibold14"
            style={{ padding: `${pxToRem(0)} ${pxToRem(8)}` }}
          />
        </Button>
      }
    />
  );
};
